import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function LegalModal({
  type,
  onClose
}: {
  type: 'privacy' | 'terms';
  onClose: () => void;
}) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={type === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'} data-id="element-43">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-night-900/80 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-44" />

      {/* Modal */}
      <div className="relative bg-night-800 border border-night-600/50 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" data-id="element-45">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-night-600/40" data-id="element-46">
          <h2 className="font-playfair text-xl font-bold text-cream-100" data-id="element-47">
            {type === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
          </h2>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-night-700 transition-colors" aria-label="Cerrar" data-id="element-48">
            <XIcon className="w-5 h-5 text-cream-200/60" data-id="element-49" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] font-dm-sans text-sm text-cream-200/70 leading-relaxed space-y-4" data-id="element-50">
          {type === 'privacy' ? <PrivacyContent data-id="element-51" /> : <TermsContent data-id="element-52" />}
        </div>
      </div>
    </div>;
}
function PrivacyContent() {
  return <>
      <p className="text-cream-200/40 text-xs" data-id="element-53">
        Última actualización: marzo 2026
      </p>

      <h3 className="font-playfair text-lg font-semibold text-cream-100 mt-4" data-id="element-54">
        1. Información que recopilamos
      </h3>
      <p data-id="element-55">
        Al adquirir el Método Noches en Paz, recopilamos únicamente la
        información necesaria para procesar tu compra y entregarte el producto
        digital: nombre, correo electrónico y datos de pago. No almacenamos
        información de tarjetas de crédito; esta es procesada de forma segura
        por nuestro proveedor de pagos.
      </p>

      <h3 className="font-playfair text-lg font-semibold text-cream-100 mt-4" data-id="element-56">
        2. Uso de la información
      </h3>
      <p data-id="element-57">
        Tu información personal se utiliza exclusivamente para: procesar y
        entregar tu compra, enviarte el acceso al material adquirido, y
        comunicarte actualizaciones importantes sobre el producto. No
        compartimos, vendemos ni cedemos tu información a terceros con fines
        comerciales.
      </p>

      <h3 className="font-playfair text-lg font-semibold text-cream-100 mt-4" data-id="element-58">
        3. Protección de datos
      </h3>
      <p data-id="element-59">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción. Toda la comunicación se realiza
        mediante conexiones cifradas (SSL/TLS).
      </p>

      <h3 className="font-playfair text-lg font-semibold text-cream-100 mt-4" data-id="element-60">
        4. Cookies
      </h3>
      <p data-id="element-61">
        Nuestro sitio puede utilizar cookies esenciales para el funcionamiento
        del proceso de compra y cookies analíticas para mejorar la experiencia
        del usuario. Puedes configurar tu navegador para rechazar cookies,
        aunque esto podría afectar la funcionalidad del sitio.
      </p>

      <h3 className="font-playfair text-lg font-semibold text-cream-100 mt-4" data-id="element-62">
        5. Tus derechos
      </h3>
      <p data-id="element-63">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. También puedes solicitar la limitación del
        tratamiento de tus datos o la portabilidad de los mismos.
      </p>

      <h3 className="font-playfair text-lg font-semibold text-cream-100 mt-4" data-id="element-64">
        6. Cambios en esta política
      </h3>
      <p data-id="element-65">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de la última actualización.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-cream-200/40 text-xs" data-id="element-66">
        Última actualización: marzo 2026
      </p>

      <h3 className="font-playfair text-lg font-semibold text-cream-100 mt-4" data-id="element-67">
        1. Producto digital
      </h3>
      <p data-id="element-68">
        El Método Noches en Paz es un producto digital (eBook) que se entrega
        mediante descarga inmediata tras confirmar el pago. Al completar la
        compra, recibirás acceso al material en formato digital.
      </p>

      <h3 className="font-playfair text-lg font-semibold text-cream-100 mt-4" data-id="element-69">
        2. Uso personal
      </h3>
      <p data-id="element-70">
        El contenido adquirido es para uso personal y familiar exclusivamente.
        Queda prohibida la reproducción, distribución, modificación o reventa
        total o parcial del material sin autorización expresa por escrito.
      </p>

      <h3 className="font-playfair text-lg font-semibold text-cream-100 mt-4" data-id="element-71">
        3. Propiedad intelectual
      </h3>
      <p data-id="element-72">
        Todo el contenido del Método Noches en Paz, incluyendo textos, gráficos,
        tablas, protocolos y metodologías, está protegido por derechos de autor.
        La compra otorga una licencia de uso personal, no la transferencia de
        propiedad intelectual.
      </p>

      <h3 className="font-playfair text-lg font-semibold text-cream-100 mt-4" data-id="element-73">
        4. Descargo de responsabilidad
      </h3>
      <p data-id="element-74">
        El contenido de este eBook tiene fines informativos y educativos. No
        sustituye el consejo médico profesional. Si tu bebé presenta problemas
        de salud o trastornos del sueño severos, consulta con tu pediatra. Los
        resultados pueden variar según cada familia y situación particular.
      </p>

      <h3 className="font-playfair text-lg font-semibold text-cream-100 mt-4" data-id="element-75">
        5. Política de reembolso
      </h3>
      <p data-id="element-76">
        Dado que se trata de un producto digital de descarga inmediata, no se
        realizan reembolsos una vez completada la descarga. Te recomendamos
        revisar toda la información disponible antes de realizar tu compra.
      </p>

      <h3 className="font-playfair text-lg font-semibold text-cream-100 mt-4" data-id="element-77">
        6. Modificaciones
      </h3>
      <p data-id="element-78">
        Nos reservamos el derecho de modificar estos términos y condiciones en
        cualquier momento. Las modificaciones entrarán en vigor desde su
        publicación en esta página.
      </p>
    </>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-night-900 border-t border-night-700/50 py-10 px-5" data-id="element-79">
        <div className="max-w-3xl mx-auto text-center" data-id="element-80">
          <p className="font-playfair text-lg text-cream-200/40 mb-3" data-id="element-81">
            Método Noches en Paz
          </p>

          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-82">
            <button onClick={() => setActiveModal('privacy')} className="font-dm-sans text-xs text-cream-200/30 hover:text-cream-200/60 underline underline-offset-2 transition-colors" data-id="element-83">
              Política de Privacidad
            </button>
            <span className="text-cream-200/15" aria-hidden="true" data-id="element-84">
              ·
            </span>
            <button onClick={() => setActiveModal('terms')} className="font-dm-sans text-xs text-cream-200/30 hover:text-cream-200/60 underline underline-offset-2 transition-colors" data-id="element-85">
              Términos y Condiciones
            </button>
          </div>

          <p className="font-dm-sans text-xs text-cream-200/20" data-id="element-86">
            © {new Date().getFullYear()} Todos los derechos reservados.
          </p>
        </div>
      </footer>

      {activeModal && <LegalModal type={activeModal} onClose={() => setActiveModal(null)} data-id="element-87" />}
    </>;
}